/*
  PDP stock message renderer.

  Expects on window (set up by product-variant-selector.liquid):
    - getSelectedVariantKey(): string
    - currentProductVariantsStockJSON: { [variantKey]: number }
    - currentProductVariantsStockMessageJSON: { [variantKey]: string }
    - currentProductVariantsEuEtaJSON: { [variantKey]: string }
    - currentProductVariantsEuQtyJSON: { [variantKey]: number }
    - isTradeCustomer: boolean

  Expects in the DOM:
    - .instock_msg               — the "IN STOCK" badge
    - .available-soon            — the dynamic message container
    - .ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity — qty input
    - <html class="eu-visitor">  — set by geoip.js for EU visitors
*/
window.setVariantStockMessage = function setVariantStockMessage() {
  const selectedVariant = getSelectedVariantKey();
  const rawMessage = currentProductVariantsStockMessageJSON[selectedVariant];
  const stockQty = currentProductVariantsStockJSON[selectedVariant] || 0;
  const qtyInput = $(".ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity").first();
  const selectedQty = parseInt(qtyInput.val()) || 1;
  const leadTimeText = (typeof rawMessage !== "undefined" && rawMessage.trim() !== "") ? rawMessage.trim() : "";
  const fallbackMessage = "Inquire to a Harbour Showroom for Lead Times, <a href='tel:13104395972'>CALL US +1 310 439 5972</a>";

  // EU visitor logic
  const euEta = currentProductVariantsEuEtaJSON[selectedVariant];
  const isEuVisitor = document.documentElement.classList.contains('eu-visitor');
  const euQty = currentProductVariantsEuQtyJSON[selectedVariant];
  const availableQty = isEuVisitor && typeof euQty === "number" ? euQty : stockQty;
  const isInStockForQty = availableQty > 0 && availableQty >= selectedQty;

  if (isEuVisitor && euEta && euEta.trim() !== "") {
    if (isInStockForQty) {
      $(".instock_msg").removeClass("hide");
      $(".available-soon").removeClass("eu-eta-visible").hide();
    } else {
      const euHtml = "<div class=\"custom_message\"><b>Availability: </b>" + euEta + "</div>";
      $(".available-soon").html(euHtml);
      $(".available-soon").addClass("eu-eta-visible").show();
      $(".instock_msg").addClass("hide");
    }
    return;
  } else {
    $(".available-soon").removeClass("eu-eta-visible");
  }

  // Trade customer logic
  if (isTradeCustomer) {
    if (stockQty > 0) {
      $(".instock_msg").removeClass("hide");
      if (selectedQty > stockQty) {
        const overQty = selectedQty - stockQty;
        if (leadTimeText) {
          $(".available-soon").html("<div class=\"custom_message\"><b>" + stockQty + " In Stock</b> and <b>" + overQty + " with an Estimated Arrival of " + leadTimeText + "</b></div>");
        } else {
          $(".available-soon").html("<div class=\"custom_message\"><b>" + stockQty + " In Stock</b> and <b>" + overQty + " on Backorder.</b> " + fallbackMessage + "</div>");
        }
      } else {
        $(".available-soon").html("<div class=\"custom_message\"><b>" + stockQty + " Units Available</b></div>");
      }
      $(".available-soon").show();
    } else {
      $(".instock_msg").addClass("hide");
      if (leadTimeText) {
        $(".available-soon").html("<div class=\"custom_message\"><b>Estimated Arrival: </b>" + leadTimeText + "</div>");
      } else {
        $(".available-soon").html("<div class=\"custom_message\">" + fallbackMessage + "</div>");
      }
      $(".available-soon").show();
    }
    return;
  }

  // Regular customer fallback
  if (stockQty > 0) {
    $(".instock_msg").removeClass("hide");
    $(".available-soon").hide();
  } else {
    $(".instock_msg").addClass("hide");
    if (leadTimeText) {
      $(".available-soon").html("<div class=\"custom_message\"><b>Availability: </b>" + leadTimeText + "</div>");
    } else {
      $(".available-soon").html("<div class=\"custom_message\">" + fallbackMessage + "</div>");
    }
    $(".available-soon").show();
  }
};
